import React from 'react';
import { DatePicker } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import moment from 'moment';

const DateTimeEditor = ({ value, pendingValue, onChange }) => {
  // 解析输入的数组
  const parseInputValue = (inputValue) => {
    if (!Array.isArray(inputValue) || inputValue.length < 8) {
      return moment(); // 返回当前日期时间，如果输入无效
    }
    return moment()
      .year(inputValue[0] + 2000)
      .month(inputValue[1] - 1) // moment 的月份是 0-11
      .date(inputValue[2])
      .hour(inputValue[4])
      .minute(inputValue[5])
      .second(inputValue[6]);
  };

  function compareDateTimeArrays(arr1, arr2) {
    // 假设数组格式为 [year-2000, month, day, unknown, hour, minute, second, weekday]
    const date1 = new Date(arr1[0] + 2000, arr1[1] - 1, arr1[2], arr1[4], arr1[5], arr1[6]);
    const date2 = new Date(arr2[0] + 2000, arr2[1] - 1, arr2[2], arr2[4], arr2[5], arr2[6]);
    
    return date1 - date2;
  }

  var ok = pendingValue == null || compareDateTimeArrays(pendingValue, value) != 0;

  // 将 moment 对象转换为输出数组
  const formatOutputValue = (date) => {
    return [
      date.year() - 2000,
      date.month() + 1, // 转换回 1-12 的月份
      date.date(),
      0, // 第四个元素，根据需要设置
      date.hour(),
      date.minute(),
      date.second(),
      date.day(), // 0-6，表示星期日到星期六
    ];
  };

  const dateValue = parseInputValue(value);

  const onDateTimeChange = (date) => {
    if (date) {
      onChange?.(formatOutputValue(date));
    }
  };

  return (ok ?
    <DatePicker
      showTime
      format="YYYY-MM-DD HH:mm:ss"
      value={dateValue}
      onChange={onDateTimeChange}
      allowClear={false}
    />
    :
    <DatePicker
      showTime
      format="YYYY-MM-DD HH:mm:ss"
      value={dateValue}
      onChange={onDateTimeChange}
      suffixIcon={<EditOutlined />}
      allowClear={false}
    />
  );
};

export default DateTimeEditor;